import React, {useContext} from "react";
import {T, useTranslate} from "@tolgee/react";
import FlexBox from "view/components/Layout/FlexBox";
import {DiscountCodeType, ISupplierCompany} from "@evennt-tech/api-v2-core";

import {Typography} from "@material-ui/core";
import {CurrencyContext} from "view/context/CurrencyContext";
import formatPrice from "tools/formats/formatPrice";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  CartDiscountCode,
  useShowDiscountCodesActions,
} from "store/discount-code/discount-code-store";
import {useCurrentShowId} from "hooks";
import clsx from "clsx";
import {DISCOUNT_CODE_ERROR_MESSAGE} from "view/apps/Exhibitor/pages/Cart/components/DiscountCodes/helpers";
import useStyles from "./styles";

type Props = {
  discountCode: CartDiscountCode;
  supplierCompany: ISupplierCompany;
};

const AppliedDiscountCode = ({supplierCompany, discountCode}: Props) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const currency = useContext(CurrencyContext);
  const showId = useCurrentShowId();
  const {removeOne} = useShowDiscountCodesActions();

  const discountValue = (() => {
    const discountRule = discountCode.rules?.[0];
    if (!discountRule) {
      return null;
    }

    const value =
      discountRule.type === DiscountCodeType.Fixed
        ? formatPrice(discountRule.amount, currency)
        : `${discountRule.amount}%`;

    return `(-${value})`;
  })();

  const shouldShowError = !!discountCode.error;

  return (
    <FlexBox
      fullWidth
      column
      gap={0.5}
      className={clsx(classes.item, shouldShowError && classes.itemError)}
    >
      <FlexBox justifyBetween fullWidth gap={1}>
        <Typography
          variant="h4"
          color={discountCode.error ? "error" : "primary"}
          className={clsx(classes.discountItemTitle)}
        >
          {discountCode.code} {discountValue}
        </Typography>
        <IconButton
          className={classes.removeBtn}
          onClick={() => removeOne(showId, discountCode.id)}
        >
          <CloseIcon className={classes.removeIcon} />
        </IconButton>
      </FlexBox>
      <Typography variant="h5" className={classes.discountItemSupplier}>
        <T
          keyName="exhibitor.cart.discount.with_supplier"
          params={{supplier: supplierCompany?.name ?? ""}}
        />
      </Typography>
      {shouldShowError && (
        <Typography variant="h4" color="error">
          {t(DISCOUNT_CODE_ERROR_MESSAGE[discountCode.error!])}
        </Typography>
      )}
    </FlexBox>
  );
};

export default AppliedDiscountCode;
